import { orderBy, uniqBy } from "lodash";
import { CBSaltospi } from "../../../services/api";

export async function fetchEventoProva({ idEvento }) {
  const res = await CBSaltospi.get("evento-prova", {
    params: {
      id_evento: idEvento,
      expand: "classificacao,aparelho,classe,altura",
      sort: "id_classe",
      pageSize: 1000,
    },
  });

  if (res.data._meta.totalCount === 0) {
    return { provas: [], classes: [] };
  }

  const provas = orderBy(
    res.data.items,
    ["altura.id", "aparelho.id", "classe.id"],
    ["asc", "asc", "asc"]
  );

  const classes = res.data.items.map((item) => ({
    id: item.id_classe,
    classe: item.classe,
    aparelho: item.aparelho.tipo_aparelho,
  }));

  return {
    provas,
    classes: uniqBy(classes, "id"),
  };
}
